import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { IObjectDto } from '@fi-shared/models/models';
import { ObjectTypes } from '@fi-shared/types';
import { FiSignalRHelperService } from '@fi-shared/fi-signal-r/fi-signal-r-helper.service';
import { ILightWeightUser } from '@fi-shared/models';
import { INewsFeedGrouped } from '@fi-shared/fi-news-feed-shared/fi-news-feed-shared';

@Injectable()
export class FiNewsFeedSharedService {
    constructor(
        private fiBackend: FiBackendService,
        private fiSignalRHelperService: FiSignalRHelperService,
    ) {}

    markNewsFeedsAsVisited(data: IObjectDto[]) {
        return this.fiBackend.fetchDataPost('NewsFeed/NewsFeed/MarkNewsFeedsAsVisited', data);
    }

    markAllNewsFeedsAsSeen() {
        const showForumActivity = this.fiSignalRHelperService.showForumActivityInNewsFeed;
        const promise = this.fiBackend.fetchDataPost<void>(
            'NewsFeed/NewsFeed/MarkAllNewsFeedsAsSeen/' + showForumActivity,
        );
        promise.then(() => {
            this.fiSignalRHelperService.clearNewNewsFeeds();
        });
        return promise;
    }

    markAllForumPostsAsSeen() {
        return this.fiBackend.fetchDataPost('NewsFeed/NewsFeed/MarkAllForumPostsAsSeen');
    }

    getObjectItem(newsFeed: INewsFeedGrouped) {
        const objectItems = this.getObjectItems([newsFeed]);
        return objectItems.length ? objectItems[0] : null;
    }

    getObjectItems(newsFeeds: INewsFeedGrouped[]) {
        let objectItems: {
            ObjectId;
            ObjectType;
        }[] = [];
        newsFeeds.forEach((newsFeed) => {
            if (newsFeed.GroupedItems && !newsFeed.ObjectId) {
                objectItems = objectItems.concat(
                    newsFeed.GroupedItems.map((groupedItem) => ({
                        ObjectId: groupedItem.ObjectId,
                        ObjectType: groupedItem.ObjectType,
                    })),
                );
            } else {
                objectItems.push({
                    ObjectId: newsFeed.ObjectId,
                    ObjectType: newsFeed.ObjectType,
                });
            }
        });
        return objectItems;
    }

    getUsersWithNewsFeedAccess(objectId: number, objectType: ObjectTypes) {
        return this.fiBackend.fetchData<ILightWeightUser[]>(
            `NewsFeed/NewsFeed/GetUsersWithNewsFeedAccess/${objectId}/${objectType}`,
        );
    }

    useNewsFeedItemForComments(newsItem: INewsFeedGrouped) {
        // special case https://chainformation.atlassian.net/browse/FI-4676
        return newsItem.ObjectType === ObjectTypes.MediaBankGrouped || newsItem.ObjectType === ObjectTypes.MediaBank;
    }
}
